exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_tabBar_3SjqYBbZQhm_6tT-treXpG {\n  width: 100%;\n  position: absolute;\n  z-index: 999999;\n}", ""]);

// Exports
exports.locals = {
	"IA_tabBar": "IA_tabBar_3SjqYBbZQhm_6tT-treXpG"
};